import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/main';

interface RemoveChildUserRequest {
  email: string;
}

const useRemoveChildUser = () => {
  const client = supabaseClient;

  const mutationFn = async (request: RemoveChildUserRequest) => {
    return removeChildUser(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['child-users'] });
    },
  });
};

async function removeChildUser(client: SupabaseClient, request: RemoveChildUserRequest): Promise<void> {
  const { error } = await client.functions.invoke('remove_child_user', {
    method: 'POST',
    body: request,
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();

    if (errorMessage.error) {
      throw new Error(errorMessage.error);
    }

    throw new Error(error.message);
  }
}

export default useRemoveChildUser;
